import React, { FC, PropsWithChildren } from 'react';
import '../../assets/styles/styles.css';
import '../../tailwind.css';

const ThemeWrapper: FC<PropsWithChildren<object>> = ({ children }) => <React.Fragment>{children}</React.Fragment>;

export default ThemeWrapper;
